import * as yup from 'yup'
import { ApplicationFormAnswers } from '../components/ApplicationForm/ApplicationFormContext'
import MaritalStatusOptions from '../components/Questions/MaritalStatusQuestion/MaritalStatusOptions'
import BaseValidator from './BaseValidator'

const MaritalStatusValidator = (): BaseValidator => {
  const schema = yup.object().shape({
    maritalStatus: yup.string()
      .oneOf(MaritalStatusOptions.map((o) => o.value))
      .required()
  })

  return {
    getValidator: () => schema,
    validateState: (state: ApplicationFormAnswers) => schema.isValidSync({
      maritalStatus: state.maritalStatus
    })
  }
}

export default MaritalStatusValidator
